import React, { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const successStories = [
  
  {
    rank: "AIR 54",
    name: "Shreyas Kadam",
    exam: "CAPF AC 2024",
    image: "/images/success_story/shreyas_kadam.webp",
    testimonial: "The faculty's personalized attention and strategic approach to preparation made all the difference. Their current affairs sessions were particularly valuable.",
    achievement: "Topped CAPF Assistant Commandant Exam",
  },
  {
    rank: "AIR 288",
    name: "Kiran Shinde",
    exam: "CAPF AC 2024",
    image: "/images/success_story/kiran_shinde.webp",
    testimonial: "The institute's structured curriculum and regular assessments kept me on track. The interview preparation sessions boosted my confidence significantly.",
    achievement: "Achieved Top 300 rank in CAPF AC",
  },
  {
    rank: "AIR 421",
    name: "Ajinkya Mane",
    exam: "CSE 2021",
    image: "/images/success_story/ajinkya_mane.webp",
    testimonial: "The quality of teaching and the supportive environment here is exceptional. The mentorship program helped me stay motivated throughout my journey.",
    achievement: "Successfully cleared UPSC Civil Services",
  },
  {
    rank: "AIR 610",
    name: "Rushikesh Gaikwad",
    exam: "CSE 2024",
    image: "/images/success_story/rushikesh_gaikwad.webp",
    testimonial: "The institute's test series and detailed performance analysis helped me identify my weak areas and work on them systematically.",
    achievement: "Cracked UPSC in first attempt",
  },
  {
    rank: "AIR 628",
    name: "Saurav Dhakane",
    exam: "CSE 2024",
    image: "/images/success_story/saurav_dhakane.webp",
    testimonial: "The dedication of the faculty and their innovative teaching methods made complex topics easy to understand. Highly recommend this institute.",
    achievement: "Secured top rank in Civil Services",
  },
  {
    rank: "AIR 902",
    name: "Dayanand Tendolkar",
    exam: "CSE 2022",
    image: "/images/mentors/dayanand.webp",
    testimonial: "The comprehensive study plan and regular doubt-clearing sessions provided by the institute were crucial for my success in the examination.",
    achievement: "Achieved success in Civil Services Exam",
  },
  {
    rank: "AIR 383",
    name: "Rutik Yadav",
    exam: "CAPF AC 2024",
    image: "/images/success_story/rutik_yadav.webp",
    testimonial: "The institute's focus on both theoretical knowledge and practical application helped me excel in all stages of the examination process.",
    achievement: "Top performer in CAPF Assistant Commandant",
  },
];

const Success = () => {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -320, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 320, behavior: "smooth" });
  };

  // Auto-scroll in loop
  useEffect(() => {
    const container = scrollRef.current;
    let scrollInterval = setInterval(() => {
      if (container) {
        if (container.scrollLeft + container.offsetWidth >= container.scrollWidth) {
          container.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          container.scrollBy({ left: 320, behavior: "smooth" });
        }
      }
    }, 3000); // scroll every 3 seconds

    return () => clearInterval(scrollInterval);
  }, []);

 return (
  <div className="bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 py-12">
    <div className="max-w-6xl mx-auto px-4">

      {/* Scroll Container */}
      <div className="overflow-x-auto scroll-smooth no-scrollbar" ref={scrollRef}>
        <div className="flex space-x-6 px-4">
          {successStories.map((story, index) => (
            <div
              key={index}
              className="w-80 flex-shrink-0 bg-white rounded-xl shadow-lg hover:shadow-xl transition-transform duration-300"
            >
              <div className="p-6 flex flex-col justify-between h-full">
                <div className="flex items-center space-x-4 mb-4">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-blue-500"
                  />
                  <div>
                    <h4 className="text-lg font-semibold">{story.name}</h4>
                    <p className="text-blue-600 text-sm">{story.exam}</p>
                    <p className="text-xs text-gray-500">{story.duration}</p>
                  </div>
                </div>
                <p className="text-gray-600 text-sm italic mb-3">"{story.testimonial}"</p>
                <div className="bg-blue-50 text-blue-700 text-sm p-3 rounded-md border-l-4 border-blue-500">
                  {story.achievement}
                </div>
                <div className="flex justify-center mt-4">
                  
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Buttons at Bottom */}
      <div className="flex justify-center mt-6 space-x-4">
        <button onClick={scrollLeft} className="bg-white shadow-md rounded-full p-3 hover:bg-blue-100">
          <ChevronLeft className="text-blue-600 w-6 h-6" />
        </button>
        <button onClick={scrollRight} className="bg-white shadow-md rounded-full p-3 hover:bg-blue-100">
          <ChevronRight className="text-blue-600 w-6 h-6" />
        </button>
      </div>
    </div>
  </div>
);
}
export default Success;
